/** Normalize file-upload API payloads ({ result: { url } } or legacy shapes). */
export function resolveUploadUrl(data) {
  const result = data?.result;
  if (!result) return null;
  if (typeof result === "string") return result;
  return result.url || result.secure_url || null;
}

const SLOW_SAVE =
  "The server took too long to answer. Your change may still have saved, so check the list before trying again.";

export function getApiErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  const status = err?.response?.status;
  if (err?.code === "ECONNABORTED" || status === 502 || status === 503 || status === 504) return SLOW_SAVE;
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  return data.message || data.mesasge || fallback;
}
